import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule, Routes } from '@angular/router'
import { DiscountCodeComponentModule } from '@src/app/components/discount-code/discount-code.component.module.js'
import { MeasureStepsComponentModule } from '@src/app/components/measure-steps/measure-steps.component.module.js'
import { ReviewsComponent } from '@src/app/components/reviews/reviews.component.js'
import { StarRatingComponent } from '@src/app/components/star-rating/star-rating.component.js'
import { SharedModule } from '@src/app/shared/shared.module.js'
import { SecretPage } from './secret.page.component.js'

const ROUTES: Routes = [
  {
    path: '',
    component: SecretPage,
  },
]

@NgModule({
  declarations: [SecretPage],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    RouterModule.forChild(ROUTES),
    DiscountCodeComponentModule,
    StarRatingComponent,
    MeasureStepsComponentModule,
    ReviewsComponent,
  ],
  exports: [],
  providers: [],
})
export class SecretPageModule {}
